var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_10864)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.338 93C97.3875 93 91.3033 97.6678 89.5033 104.381C84.3122 123.742 80.8582 154.03 87.9587 182.461C94.2445 207.63 109.165 232.125 138.453 244.832C134.398 263.408 133.952 287.403 142.467 311.991C153.055 342.567 177.013 372.645 221.832 393.987V441.641C221.832 450.124 228.708 457 237.19 457H292.481C300.964 457 307.84 450.124 307.84 441.641V393.987C352.659 372.645 376.617 342.567 387.205 311.991C395.72 287.403 395.274 263.408 391.218 244.832C420.507 232.125 435.427 207.63 441.713 182.461C448.813 154.03 445.359 123.742 440.168 104.381C438.368 97.6678 432.284 93 425.334 93H381.562C376.625 93 371.989 95.3732 369.102 99.3783C366.215 103.383 365.43 108.532 366.991 113.215C368.222 116.908 369.117 123.351 369.588 131.513C370.028 139.134 370.042 146.954 370.042 153.2C369.206 166.069 363.894 173.814 358.989 177.843C347.7 164.434 331.508 156.309 316.729 151.383C297.605 145.009 277.683 142.916 264.836 142.916C251.988 142.916 232.067 145.009 212.943 151.383C198.164 156.309 181.971 164.434 170.682 177.843C165.777 173.814 160.466 166.069 159.629 153.2C159.629 146.954 159.644 139.134 160.083 131.513C160.554 123.351 161.45 116.908 162.681 113.215C164.242 108.532 163.456 103.383 160.57 99.3783C157.683 95.3732 153.047 93 148.11 93H104.338Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.234 93C93.7628 128.325 91.1006 218.48 156.221 235.067C143.422 268.089 141.477 344.114 236.086 384.046V441.641H263.732H291.377V384.046C385.987 344.114 384.041 268.089 371.242 235.067C436.363 218.48 433.701 128.325 424.229 93H380.457C384.297 104.519 384.297 141.124 384.297 153.667C382.761 180.544 365.355 195.647 352.044 196.671C336.685 165.954 286.77 158.274 263.732 158.274C240.694 158.274 190.778 165.954 175.42 196.671C162.109 195.647 144.702 180.544 143.166 153.667C143.166 141.124 143.166 104.519 147.006 93H103.234Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.646 278.84C158.064 278.281 182.908 279.526 211.868 292.274C220.287 295.629 242.344 299.151 263.223 286.403C274.168 279.414 304.475 268.79 338.151 282.209C346.008 285.564 362.62 291.895 375.416 291.895C373.236 318.054 348.365 362.778 291.71 384.427V457H234.883V384.714C202.87 371.582 153.169 342.974 149.646 278.84Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.224,
    cy: 337.971,
    r: 14.5907,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.996,
    cy: 389.422,
    r: 9.21519,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.713,
    cy: 352.561,
    r: 9.21519,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.287,
    cy: 315.7,
    r: 15.3586,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1029 347.693L25.078 342.824L64.7999 366.519L58.0634 379.376L136.164 384.537L92.1946 360.246L99.1029 347.693Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.721 422.887L84.3162 478.219L121.331 458.387L128.186 469.641L168.725 411.275L129.26 434.134L122.721 422.887Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.898 347.693L504.922 342.824L465.201 366.519L471.937 379.376L393.837 384.537L437.806 360.246L430.898 347.693Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.279 422.887L445.684 478.219L408.669 458.387L401.814 469.641L361.276 411.275L400.74 434.134L407.279 422.887Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_10864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/일반외과_방광염.c6c601f06cdef57a2be557d9894b04be.svg";
export { ForwardRef as ReactComponent };